module.exports = __webpack_public_path__ + "img/235.8d3d462a.png";